module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_1.18d87055.png";